import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export interface DataConfirmModal {
  title: string
  msg: string
  extra?: string
  yes: string
}

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent {
  public data: DataConfirmModal

  constructor(public modal: NgbActiveModal) {}
}
